import yes1 from "./yes1.mp3";
const yes = [yes1];
export default yes;
